import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

const markMentionsSeenFn = async (): Promise<void> => {
  await api.post('/dashboard/mentions/seen');
};

export const useMarkMentionsSeen = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, void>({
    mutationFn: markMentionsSeenFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mentions', 'unseen-count'] });
    },
  });
};
